/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-var */
import clientConfiguration from "./client-configuration";
import { isNo3rdparty } from "./util/browser-detection";
import { Cookie } from "./util/cookie";

let fbLoaded = false;
let gtmLoaded = false;

declare const fbq: any;
const loadFb = () => {
  console.log("loadFb");
  if (fbLoaded) return;
  (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  fbq("init", "653644375453926");
  fbq("track", "PageView", { hostname: location.hostname });

  //const appId = "603210533761694";
  //const script = document.createElement("script");
  //script.async = true;
  //script.crossOrigin = "anonymous"
  //script.src = `https://connect.facebook.net/da_DK/sdk.js#xfbml=1&version=v6.0&appId=${appId}&autoLogAppEvents=1`
  //document.getElementsByTagName("script")[0].parentNode.insertBefore(script, document.getElementsByTagName("script")[0]);
  fbLoaded = true;
};

interface Window {
  _sp_queue: any[];
  _sp_: {
    config: {
      accountId: number;
      baseEndpoint: string;
      propertyHref: string;
      gdpr: any;
      events: {
        onMessageChoiceSelect: Function;
        onMessageReady: Function;
        onMessageChoiceError: Function;
        onPrivacyManagerAction: Function;
        onPMCancel: Function;
        onMessageReceiveData: Function;
        onSPPMObjectReady: Function;
        onConsentReady: (consentUUID: string, euconsent: string) => void;
        onError: Function;
      };
    };
  };
}

interface SpecificConsent {
  purpose?: string;
  allowed: boolean;
}

interface Concept {
  specificConsent: SpecificConsent[];
}

const loadGtm = () => {
  if (gtmLoaded) return;

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    const f = d.getElementsByTagName(s)[0],
      j: any = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode!.insertBefore(j, f);
  })(window, document, "script", "dataLayer", clientConfiguration.gtmId);
  gtmLoaded = true;
};

function generateDeferredPromise() {
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    [resolve, reject] = [res, rej];
  });
  return { promise, reject, resolve };
}

const { promise, resolve } = generateDeferredPromise();

export const cookieDecision = promise;

declare const concept: Concept;

declare const window: Window;

window._sp_queue = [];
window._sp_ = {
  config: {
    accountId: 1423,
    baseEndpoint: "https://cdn.privacy-mgmt.com",
    propertyHref: "https://vores.dk",
    gdpr: {},
    events: {
      onMessageChoiceSelect: function () {
        //console.log("[event] onMessageChoiceSelect", arguments);
      },
      onMessageReady: function () {
        //console.log("[event] onMessageReady", arguments);
      },
      onMessageChoiceError: function () {
        //console.log("[event] onMessageChoiceError", arguments);
      },
      onPrivacyManagerAction: function () {
        //console.log("[event] onPrivacyManagerAction", arguments);
      },
      onPMCancel: function () {
        //console.log("[event] onPMCancel", arguments);
      },
      onMessageReceiveData: function () {
        //console.log("[event] onMessageReceiveData", arguments);
      },
      onSPPMObjectReady: function () {
        //console.log("[event] onSPPMObjectReady", arguments);
      },
      onConsentReady: function (consentUUID, euconsent) {
        //console.log("[event] onConsentReady", arguments);
        //console.log(consentUUID);
        //console.log(euconsent);

        const fbConsent = concept.specificConsent.find(
          (c) => c.purpose === "Measure content performance"
        );

        if (fbConsent) {
          loadFb();
        }

        //Always load gtm
        if (!isNo3rdparty()) {
          loadGtm();
        }

        resolve();
      },
      onError: function () {
        //console.log("[event] onError", arguments);
      },
    },
  },
};

// loadGtm();

const script = document.createElement("script");
script.src =
  "https://cdn.privacy-mgmt.com/unified/wrapperMessagingWithoutDetection.js";
script.async = true;
document.head.appendChild(script);
